import {
  Skeleton,
  TableCell,
  TableRow,
  Theme,
  Typography,
} from "@mui/material";
import { InsuranceCompanyTurnoverData, InsurancePolicyDetailsData, InsurancePremiumScheduleData } from "../../../redux-store/types/products";
import { TableHeaderData } from "../types";
import { formatCurrency } from "../../../utils/utilityFunctions";
import { RootStateType } from "../../../redux-store/reducers";
import { useSelector } from "react-redux";
import { USER_ROLES } from "../../../utils/constant";
import { useHistory } from "react-router";


// const history = useHistory();
// const { pathname: pathName } = history.location;
// const isInvestorView = !pathName.includes('product');

export const CompanyTurnoverTableHeaderDataUY: TableHeaderData[] = [
  {
    id: "insCompanyName",
    label: "INSURANCE COMPANY",
    align: "left",
    isSortable: false
  },
  {
    id: "policyCount",
    label: "POLICY COUNT",
    align: "center",
    isSortable: false
  },
  {
    id: "marketValue",
    label: "MARKET VALUE",
    align: "center",
    isSortable: false
  },
  {
    id: "premiumPaid",
    label: "PREMIUM PAID",
    align: "center",
    isSortable: false
  },
  {
    id: "gainLoss",
    label: "GAIN LOSS",
    align: "center",
    isSortable: false
  },
]
export const CompanyTurnoverTableHeaderDataUN: TableHeaderData[] = [
  {
    id: "insCompanyName",
    label: "INSURANCE COMPANY",
    align: "left",
    isSortable: false
  },
  {
    id: "policyCount",
    label: "POLICY COUNT",
    align: "center",
    isSortable: false
  },
  {
    id: "premiumPaid",
    label: "PREMIUM PAID",
    align: "center",
    isSortable: false
  },
]
export function CompanyTurnoverDataTableUY(
  { data }: { data: InsuranceCompanyTurnoverData[] },
  index: number
): JSX.Element {
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

  return (
    <>
      {data.map((obj: InsuranceCompanyTurnoverData) => {
        return (
          <TableRow
            key={`${obj?.insCompanyName}-${index}`}
            sx={(theme: Theme) => ({
              '& td': {
                paddingTop: '15px',
                paddingBottom: '15px',
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
              },
              '& td:first-of-type': {
                paddingLeft: '0px',
              },
            })}>
            <TableCell align="left">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.insCompanyName ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyCount ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                })}>
                {(obj?.marketValue ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                })}>
                {(obj?.premiumPaid ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.premiumPaid ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.premiumPaid ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color:
                    (obj?.gainLoss ?? 0) >= 0
                      ? theme.palette.success[500]
                      : theme.palette.error[500],
                })}>
                {obj?.gainLoss}
              </Typography>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}

export function CompanyTurnoverDataTableUN(
  { data }: { data: InsuranceCompanyTurnoverData[] },
  index: number
): JSX.Element {
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

  return (
    <>
      {data.map((obj: InsuranceCompanyTurnoverData) => {
        return (
          <TableRow
            key={`${obj?.insCompanyName}-${index}`}
            sx={(theme: Theme) => ({
              '& td': {
                paddingTop: '15px',
                paddingBottom: '15px',
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
              },
              '& td:first-of-type': {
                paddingLeft: '0px',
              },
            })}>
            <TableCell align="left">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.insCompanyName ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyCount ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                })}>
                {(obj?.premiumPaid ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.premiumPaid ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.premiumPaid ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}

export const PolicyDetailsNonInvestorData: TableHeaderData[] = [
  {
    id: "customerName",
    label: "CUSTOMER NAME",
    align: "left",
    isSortable: false
  },
  {
    id: "customer",
    label: "UCC CODE",
    align: "center",
    isSortable: false
  },
];

export const PolicyDetailsTableHeaderDataUY: TableHeaderData[] = [
  {
    id: "insCompany",
    label: "INSURANCE COMPANY",
    align: "center",
    isSortable: false
  },
  {
    id: "policyNumber",
    label: "POLICY NO",
    align: "center",
    isSortable: false
  },
  {
    id: "totalSumAssured",
    label: "SUM ASSURED",
    align: "center",
    isSortable: false
  },
  {
    id: "premiumTenure",
    label: "PREMIUM TENURE",
    align: "center",
    isSortable: false
  },
  {
    id: "totalPremium",
    label: "TOTAL PREMIUM",
    align: "center",
    isSortable: false
  },
  {
    id: "marketValue",
    label: "MARKET VALUE",
    align: "center",
    isSortable: false
  },
  {
    id: "policyCode",
    label: "POLICY CODE",
    align: "center",
    isSortable: false
  },
  {
    id: "policyStatus",
    label: "POLICY STATUS",
    align: "center",
    isSortable: false
  },
  {
    id: "policyTenure",
    label: "POLICY TENURE",
    align: "center",
    isSortable: false
  },
  {
    id: "gainLoss",
    label: "GAIN LOSS",
    align: "center",
    isSortable: false
  },
  {
    id: "policyType",
    label: "POLICY TYPE",
    align: "center",
    isSortable: false
  },
  {
    id: "return",
    label: "RETURN",
    align: "center",
    isSortable: false
  },
]

export const PolicyDetailsTableHeaderDataUN: TableHeaderData[] = [
  {
    id: "insCompany",
    label: "INSURANCE COMPANY",
    align: "center",
    isSortable: false
  },
  {
    id: "policyNumber",
    label: "POLICY NO",
    align: "center",
    isSortable: false
  },
  {
    id: "totalSumAssured",
    label: "SUM ASSURED",
    align: "center",
    isSortable: false
  },
  {
    id: "premiumTenure",
    label: "PREMIUM TENURE",
    align: "center",
    isSortable: false
  },
  {
    id: "totalPremium",
    label: "TOTAL PREMIUM",
    align: "center",
    isSortable: false
  },
  {
    id: "policyStatus",
    label: "POLICY STATUS",
    align: "center",
    isSortable: false
  },
  {
    id: "policyTenure",
    label: "POLICY TENURE",
    align: "center",
    isSortable: false
  },
  {
    id: "policyType",
    label: "POLICY TYPE",
    align: "center",
    isSortable: false
  },
]

export function PolicyDetailsDataTableUY(
  { data }: { data: InsurancePolicyDetailsData[] },
  index: number
): JSX.Element {
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
  const history = useHistory();
  const { pathname: pathName } = history.location;
  const isInvestorView = !pathName.includes('product');
  return (
    <>
      {data.map((obj: InsurancePolicyDetailsData) => {
        return (
          <TableRow
            key={`${obj?.insCompany}-${index}`}
            sx={(theme: Theme) => ({
              '& td': {
                paddingTop: '15px',
                paddingBottom: '15px',
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
              },
              '& td:first-of-type': {
                paddingLeft: '0px',
              },
            })}>
            {!isInvestorView &&
              <>
                <TableCell align="left">
                  <Typography
                    variant="body_500"
                    sx={(theme: Theme) => ({
                      lineHeight: '20px',
                      letterSpacing: '0.02px',
                      color: theme.palette.text.primary,
                      '&:hover': {
                        color: theme.palette.primary[500],
                      },
                      minWidth: '200px'

                    })}>
                    {obj?.customerName ?? '-'}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body_500"
                    sx={(theme: Theme) => ({
                      lineHeight: '20px',
                      letterSpacing: '0.02px',
                      color: theme.palette.text.primary,
                      '&:hover': {
                        color: theme.palette.primary[500],
                      },
                    })}>
                    {obj?.customer ?? '-'}
                  </Typography>
                </TableCell>
              </>
            }
            <TableCell align='center'>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  width: '120px'
                })}>
                {obj?.insCompany ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyNumber ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {(obj?.totalSumAssured ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.totalSumAssured ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.totalSumAssured ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.premiumTenure ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {(obj?.totalPremium ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.totalPremium ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.totalPremium ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {(obj?.marketValue ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyCode ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyStatus ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyTenure ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color:
                    (obj?.gainLoss ?? 0) >= 0
                      ? theme.palette.success[500]
                      : theme.palette.error[500],
                })}>
                {obj?.gainLoss} %
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyType ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color:
                    (obj?.return ?? 0) >= 0
                      ? theme.palette.success[500]
                      : theme.palette.error[500],
                })}>
                {obj?.return} %
              </Typography>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}

export function PolicyDetailsDataTableUN(
  { data }: { data: InsurancePolicyDetailsData[] },
  index: number
): JSX.Element {
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
  const history = useHistory();
  const { pathname: pathName } = history.location;
  const isInvestorView = !pathName.includes('product');
  return (
    <>
      {data.map((obj: InsurancePolicyDetailsData) => {
        return (
          <TableRow
            key={`${obj?.insCompany}-${index}`}
            sx={(theme: Theme) => ({
              '& td': {
                paddingTop: '15px',
                paddingBottom: '15px',
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
              },
              '& td:first-of-type': {
                paddingLeft: '0px',
              },
            })}>
            {!isInvestorView &&
              <>
                <TableCell align="left">
                  <Typography
                    variant="body_500"
                    sx={(theme: Theme) => ({
                      lineHeight: '20px',
                      letterSpacing: '0.02px',
                      color: theme.palette.text.primary,
                      '&:hover': {
                        color: theme.palette.primary[500],
                      },
                      minWidth: '200px'

                    })}>
                    {obj?.customerName ?? '-'}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography
                    variant="body_500"
                    sx={(theme: Theme) => ({
                      lineHeight: '20px',
                      letterSpacing: '0.02px',
                      color: theme.palette.text.primary,
                      '&:hover': {
                        color: theme.palette.primary[500],
                      },
                    })}>
                    {obj?.customer ?? '-'}
                  </Typography>
                </TableCell>
              </>
            }
            <TableCell align='center'>
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  width: '120px'
                })}>
                {obj?.insCompany ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyNumber ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {(obj?.totalSumAssured ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.totalSumAssured ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.totalSumAssured ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.premiumTenure ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {(obj?.totalPremium ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.totalPremium ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.totalPremium ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyStatus ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyTenure ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                })}>
                {obj?.policyType ?? '-'}
              </Typography>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}

export const PremiumScheduleTableHeaderData: TableHeaderData[] = [
  // {
  //   id: "customer",
  //   label: "CUSTOMER",
  //   align: "left",
  //   isSortable: false
  // },
  {
    id: "premiumDueDate",
    label: "PREMIUM DUE DATE",
    align: "left",
    isSortable: false
  },
  {
    id: "premiumFrequency",
    label: "FREQUENCY",
    align: "center",
    isSortable: false
  },
  {
    id: "basicPremium",
    label: "BASIC PREMIUM",
    align: "center",
    isSortable: false
  },
  // {
  //   id: "basicSumAssured",
  //   label: "BASIC SUM ASSURED",
  //   align: "center",
  //   isSortable: false
  // },
  {
    id: "riderPremium",
    label: "RIDER PREMIUM",
    align: "center",
    isSortable: false
  },
  // {
  //   id: "riderSumAssured",
  //   label: "RIDER SUM ASSURED",
  //   align: "center",
  //   isSortable: false
  // },
  {
    id: 'totalWithoutTax',
    label: 'TOTAL (W/O TAX)',
    align: 'center',
    isSortable: false
  },
  {
    id: 'taxes',
    label: 'TAXES',
    align: 'center',
    isSortable: false
  },
  {
    id: 'totWithTax',
    label: 'TOTAL (W/TAX)',
    align: 'center',
    isSortable: false
  },
  // {
  //   id: 'policyCode',
  //   label: 'POLICY CODE',
  //   align: 'center',
  //   isSortable: false
  // },
  // {
  //   id: 'policyStartDate',
  //   label: 'POLICY START DATE',
  //   align: 'center',
  //   isSortable: false
  // },
  // {
  //   id: 'policyEndDate',
  //   label: 'POLICY END DATE',
  //   align: 'center',
  //   isSortable: false
  // },
]

export function PremiumScheduleDataTable(
  { data }: { data: InsurancePremiumScheduleData[] },
  index: number
): JSX.Element {
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

  return (
    <>
      {data.map((obj: InsurancePremiumScheduleData) => {
        return (
          <TableRow
            key={`${obj?.customer}-${index}`}
            sx={(theme: Theme) => ({
              '& td': {
                paddingTop: '15px',
                paddingBottom: '15px',
                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
              },
              '& td:first-of-type': {
                paddingLeft: '0px',
              },
            })}>
            {/* <TableCell align="left">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'

                })}>
                {obj?.customer ?? '-'}
              </Typography>
            </TableCell> */}
            <TableCell align="left">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {obj?.premiumDueDate ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {obj?.premiumFrequency ?? '-'}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {(obj?.basicPremium ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.basicPremium ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.basicPremium ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            {/* <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {(obj?.basicSumAssured ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.basicSumAssured ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.basicSumAssured ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell> */}
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {(obj?.riderPremium ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.riderPremium ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.riderPremium ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            {/* <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {(obj?.riderSumAssured ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.riderSumAssured ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.riderSumAssured ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell> */}
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {(obj?.totalWithoutTax ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.totalWithoutTax ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.totalWithoutTax ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {(obj?.taxes ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.taxes ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.taxes ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {(obj?.totWithTax ?? 0) < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.totWithTax ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.totWithTax ?? 0, locale, currencyCode })}`}
              </Typography>
            </TableCell>
            {/* <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '80px'
                })}>
                {obj?.policyCode ?? '-'}
              </Typography>
            </TableCell> */}
            {/* <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {obj?.policyStartDate ?? '-'}
              </Typography>
            </TableCell> */}
            {/* <TableCell align="center">
              <Typography
                variant="body_500"
                sx={(theme: Theme) => ({
                  lineHeight: '20px',
                  letterSpacing: '0.02px',
                  color: theme.palette.text.primary,
                  '&:hover': {
                    color: theme.palette.primary[500],
                  },
                  minWidth: '100px'
                })}>
                {obj?.policyEndDate ?? '-'}
              </Typography>
            </TableCell> */}
          </TableRow>
        );
      })}
    </>
  );
};
